import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-319f823f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { for: "file_d_upload" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Choose File", -1))
const _hoisted_3 = { class: "file-name" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "no-file"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("input", {
        type: "file",
        id: "file_d_upload",
        name: "file_d_upload",
        accept: ".pdf",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fileHandler && _ctx.fileHandler(...args)))
      }, null, 32),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.fileName)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.fileName), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_5, " There is no file "))
    ])
  ]))
}